<template>
  <button
    class="rounded-sm border focus:outline-none text-center"
    :class="[style, sizeStyle, disabled && 'hover:cursor-not-allowed']"
    :disabled="disabledInner"
    @click.prevent="emit('click', $event)"
  >
    <Spinner v-if="loading" />
    <slot />
  </button>
</template>

<script>
import { computed } from '@vue/composition-api'
import Spinner from './Spinner'

export default {
  PRIMARY: 'primary',
  DANGER: 'danger',
  components: { Spinner },
  props: {
    type: {
      type: String,
      default: 'default',
      // choices: "primary", "danger", "default"
    },
    size: {
      type: String,
      default: 'base',
      // choices: "xs", "sm", "base", "lg", "xl"
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: [Boolean, undefined],
      default: undefined,
    },
  },
  setup(props, { emit }) {
    const style = computed(() => {
      return {
        default:
          'text-true-gray-600 bg-white hover:bg-yellow-100 hover:text-yellow-500 hover:border-yellow-300 focus:border-yellow-500',
        primary:
          'text-white bg-yellow-500 hover:bg-yellow-500 border-yellow-400 hover:border-yellow-600',
        danger:
          'text-white bg-red-500 border-red-400 hover:bg-red-400 focus:border-red-600',
      }[props.type]
    })

    const sizeStyle = computed(() => {
      return {
        sm: 'py-2 px-2 text-xs',
        base: 'py-2 px-4 text-sm',
      }[props.size]
    })

    const disabledInner = computed(() => {
      if ([true, false].includes(props.disabled)) {
        return props.disabled
      }
      return props.loading
    })

    return {
      style,
      sizeStyle,
      emit,

      disabledInner,
    }
  },
}
</script>
